import React, { useRef } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { TextForm, FormValues } from "../forms/TextForm";
import { Formik } from "formik";

export function TextEditor(props: {
  open: boolean;
  handleClose: () => void;
  initialValues: FormValues;
  onSubmit: (values: FormValues) => void;
}) {
  const formRef = useRef<Formik>(null);

  return (
    <Dialog
      maxWidth="md"
      fullWidth={true}
      scroll="paper"
      open={props.open}
      onClose={props.handleClose}
    >
      <DialogTitle>Edit Text</DialogTitle>
      <DialogContent>
        <TextForm
          formRef={formRef}
          initialValue={props.initialValues}
          onSubmit={values => {
            props.onSubmit(values);
            props.handleClose();
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={() => {
            if (!formRef || !formRef.current) return;

            formRef.current.submitForm();
          }}
          color="primary"
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
